import { useCallback, useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Formik } from 'formik';
import Sidebar from "../../../../../components/Sidebar";
import FormFields from '../Form'
import { initialValues, schema, FormValues } from '../../../../../constants/forms/category/edit'
import { createCategory } from '../../../../../store/actions/category'
import { CategoryDto, NewCategoryOutDto } from '../../../../../types/category';
import { Group } from '../../../../../types';
import { ConnectedFocusError } from '../../../../../components/ConnectedFocusError';

const convertToDays = (numero, unidad) => {
  const unidadesEnDias = {
    day: 1,
    week: 7,
    month: 30,
    year: 365,
  };

  const clave = unidad.toLowerCase().trim();

  if (!unidadesEnDias.hasOwnProperty(clave)) {
    throw new Error(`Unidad no reconocida: ${unidad}`);
  }

  return numero * unidadesEnDias[clave];
}

interface ComponentProps {
  group: Group
  groupStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  newCategory: CategoryDto;
  newCategoryStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  onClose: any
  isVisible: boolean
}

const Component = ({
  group,
  newCategoryStates,
  onClose,
  isVisible
}: ComponentProps) => {
  const dispatch = useDispatch();
  const [formSubmmited, setFormSubmmited] = useState(false);

  const onSubmit = useCallback(({ values, actions }: { values, actions }) => {

    const is_unlockable = values?.is_unlockable.includes('true');
    const days = is_unlockable ? convertToDays(values?.number_to_unlock, values?.unit_to_unlock) : null;

    const payload: NewCategoryOutDto = {
      group_id: group?.id,
      name: values?.name,
      description: values?.description,
      is_unlockable: is_unlockable,
      days_to_unlock: days,
      unlock_message: values?.unlock_message,
      grace_period_type: values?.grace_period_type,
      grace_period_in_days: values?.grace_period_in_days,
    };

    dispatch(createCategory(payload));
  }, [group]);


  return <>
    <Sidebar
      position="right"
      visible={isVisible}
      closeType="close"
      onClose={() => {
        !!onClose && onClose(false);
      }}
      width="463px"
      title={
        <div style={{ padding: "0px 18px", display: "flex", flexDirection: 'column' }}>
          <span>Crear nueva categoría</span>
          <span style={{ fontSize: 14, lineHeight: 1, fontWeight: "normal", color: "#717171" }}>Añadí una categoría para organizar tu contenido.</span>
        </div>
      }
      options={{
        style: { padding: "93px 0px 0px" },
        titleStyle: {
          top: 20,
        }
      }}
    >
      <Formik
        initialValues={{
          name: initialValues?.name,
          description: initialValues?.description,
          is_unlockable: [],
        }}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={false}
        validateOnBlur={formSubmmited}
        validationSchema={schema}
      >
        {({
          handleSubmit,
          resetForm,
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          validateForm,
          setTouched,
          validateField
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="new-category-form"
            >
              <ConnectedFocusError />
              <FormFields
                values={values}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                validateForm={validateForm}
                setTouched={setTouched}
                validateField={validateField}
                initialValues={initialValues}
                loading={newCategoryStates.loading}
                onClose={() => { onClose(false); resetForm() }}
                formId="new-category-form"
              />
            </form>
          );
        }}
      </Formik>
    </Sidebar>
  </>
}

const state = ({ groupStore, categoryStore }) => {
  const { data: categories, states: categoriesState } =
    categoryStore?.allCategories;
  const { data: group, states: groupStates } =
    groupStore.group;
  const { data: newCategory, states: newCategoryStates } = categoryStore.newCategory;

  return {
    group,
    groupStates,
    categories,
    categoriesState,
    newCategory,
    newCategoryStates,
  };
};

export default connect(state)(Component);